export enum LoginUserType {
  General = 'General',
  Tester = 'Tester',
}
